var m = require('mithril');
var prop = require('mithril/stream');
var auth = require('../../auth/models/session');
var loaders = require('../../layout/components/loaders');

var preferredNumberOfRowsEditor = {};

preferredNumberOfRowsEditor.oninit = function (vnode) {
  var ctrl = this;
  ctrl.location = vnode.attrs.location;
  ctrl.preferredNumberOfRows = vnode.attrs.preferredNumberOfRows;
  ctrl.preferredNumberOfRowsValue = vnode.attrs.preferredNumberOfRowsValue;

  ctrl.updatePreferredNumberOfRows = function (){
    ctrl.preferredNumberOfRows()[auth.user()['@rid']] = ctrl.preferredNumberOfRowsValue();
    return loaders.requestWithLoader({
      url: `/api/v1/site/${ctrl.location()['@rid'].slice(1)}`,
      method: "PUT",
      body: {
        preferredNumberOfRows: JSON.stringify(ctrl.preferredNumberOfRows())
      },
      loader: 'submit'
    })
  }
}

preferredNumberOfRowsEditor.view = function (vnode) {
  var ctrl = this;
  return m('div.w3',[
    m('select.form-control.dim.no-min-height', {
      id: 'preferredNumberOfRowsEditorSelect',
      value: ctrl.preferredNumberOfRowsValue(),
      onchange: function(ev){
        ctrl.preferredNumberOfRowsValue(ev.target.value);
        ctrl.updatePreferredNumberOfRows()
      },
    }, [
      m('option', {value: 10}, '10'),
      m('option', {value: 20}, '20'),
      m('option', {value: 30}, '30'),
      m('option', {value: 40}, '40'),
      m('option', {value: 50}, '50')
    ]),
  ])
};


module.exports = preferredNumberOfRowsEditor;